import apiClient from '../index'

export const addException = (data) => apiClient.post('/exception', data)
export const getException = (status, skip, limit) =>
  apiClient.get('/exception/getAllException', {
    params: {
      status: status === undefined || status === null ? 'all' : status,
      skip,
      limit,
    },
  })
export const getSingleEmpException = (status, skip, limit, moduleId) =>
  apiClient
    .get('/exception/getSingleEmpException', {
      params: {
        status: status === undefined || status === null ? 'all' : status,
        skip,
        limit,
        moduleId,
      },
    })
    .then((response) => {
      return response
    })
    .catch((error) => {
      console.error('Error fetching data:', error)
      throw error
    })

export const getSingleExceptionData = (id) => apiClient.get(`/exception/getSingleRequestData/${id}`)

export const deleteException = (id) => apiClient.delete(`exception/${id}`)
export const updateException = (data) => apiClient.patch('/exception/updateException', data)
